var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"mb-4",attrs:{"color":"primary","large":"","to":{ name: 'users.create' }}},[_vm._v(_vm._s(_vm.$t('Create user')))]),_c('datatable',{ref:"usersDatatable",attrs:{"config":_vm.configDatatale}}),_c('dialog-delete',{ref:"dialogDelete",on:{"yes":_vm.deleteItem}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }